import { ref, watch } from 'vue';
import { defineStore } from 'pinia';
import _cloneDeep from 'lodash/cloneDeep';

export type HelpcenterSidebarNavigationItem =
  | { type: 'article'; id: number }
  | { type: 'search'; query: string };

export interface Navigations {
  helpcenterSidebar: HelpcenterSidebarNavigationItem[];
}

const defNavigations: Navigations = {
  helpcenterSidebar: [],
};

export const useNavigationsStore = defineStore('navigations', () => {
  const navigations = ref(_cloneDeep(defNavigations));

  function $reset(): void {
    navigations.value = _cloneDeep(defNavigations);
  }

  watch(
    () => navigations.value.helpcenterSidebar,
    (newValue, oldValue) => {
      const maxLength = 10;
      if (navigations.value.helpcenterSidebar.length <= maxLength) return;
      navigations.value.helpcenterSidebar =
        navigations.value.helpcenterSidebar.slice(-maxLength);
    },
    { deep: true },
  );

  return {
    navigations,
    $reset,
  };
});
